const objectFitImages = require('object-fit-images');

$(function() {
  objectFitImages('.object-fit');
});
